import * as tslib_1 from "tslib";
import { debounceTime } from "rxjs/operators";
import { Vue, Watch, Prop, Inject } from "vue-property-decorator";
import { listApi } from "@cloudpivot/api";
import dateFormat from "@cloudpivot/common/src/utils/date";
import moment from "moment";
// @ts-ignore
import isEqual from 'lodash/isEqual';
var dayjs = require('dayjs');
import { PropertyNames, } from "h3-forms";
import { FormControlType, OperatorService, } from "@cloudpivot/form/schema";
import { ControlHelper } from "./control-helper";
// import {
//   FormControlType,
//   DataItemType,
//   OperatorService,
//   DateItemOperatorType,
// } from "../../schema";
export class BaseControl extends Vue {
    constructor() {
        super(...arguments);
        this.styleObj = {};
        this.valueChangeSubscription = null;
        this.onChangeFn = null;
    }
    get id() {
        if (this.control.parentKey) {
            return `${this.control.parentKey}-${this.control.key}`;
        }
        return this.control.key;
    }
    get ctrl() {
        if (!this.control.controller) {
            if (!this.control.parentKey) {
                const _ctrl = this.findController(this.control.key);
                this.$set(this.control, "controller", _ctrl);
                // this.$set(this.control, "edit", _ctrl.readonly === false);
                // this.control.edit = _ctrl.readonly === false;
            }
        }
        return this.control.controller;
    }
    get readonly() {
        // return this.control.edit === false;
        if (this.ctrl) {
            return !!this.ctrl.readonly;
        }
        return false;
    }
    onCtrlItemsChange(value) {
        if (value) {
            let formatString = Array.isArray(value) ? value.join(";") : value;
            this.controlOpts.options = formatString;
        }
    }
    get controlOpts() {
        return this.control.options;
    }
    get style() {
        return this.controlOpts.style || "";
    }
    get label() {
        return ControlHelper.getControlLabel(this.control, this.$i18n.locale);
    }
    get locale() {
        return this.$i18n.locale || "zh";
    }
    get placeholder() {
        // var aa = this.locale;
        if (this.controlOpts.placeholder) {
            return this.controlOpts.placeholder;
        }
        switch (this.control.type) {
            case FormControlType.Text:
            case FormControlType.Textarea:
            case FormControlType.Number:
                return this.$t("cloudpivot.form.renderer.peleseInput");
            case FormControlType.Date:
            case FormControlType.StaffSelector:
            case FormControlType.StaffMultiSelector:
            case FormControlType.DepartmentSelector:
            case FormControlType.DepartmentMultiSelector:
            case FormControlType.Dropdown:
            case FormControlType.Checkbox:
            case FormControlType.Radio:
            case FormControlType.Address:
            case FormControlType.Location:
            case FormControlType.RelevanceForm:
            case FormControlType.RelevanceFormEx:
                return this.$t("cloudpivot.form.renderer.peleseSelect");
        }
        return "";
    }
    get readonlyFormula() {
        if (this.controlOpts.readonlyFormula) {
            return this.controlOpts.readonlyFormula;
        }
    }
    // 是否为外部用户
    get isExternal() {
        if (window.isExternal) {
            return true;
        }
        return false;
    }
    getIsNew() {
        let isNew = window.h3form ? !!window.h3form.isNew : true;
        return isNew;
    }
    getPopupContainer() {
        // if (this.getScrollEl) {
        //   const scrollEl = this.getScrollEl();
        //   if (scrollEl) {
        //     return scrollEl;
        //   }
        // }
        // return triggerNode.parentNode;
        return (triggerNode) => {
            if (this.getScrollEl) {
                const scrollEl = this.getScrollEl();
                if (scrollEl) {
                    return scrollEl;
                }
            }
            return document.body;
        };
    }
    getThisProxy() {
        return this.getController().children;
    }
    getControllerGroup() {
        return this.getController();
    }
    setValue(value) {
        if (this.ctrl)
            this.ctrl.value = value;
    }
    onControlChange(c, oldControl) {
        // 防止 this.$set(this.control, 'controller', _ctrl) 时再次触发change
        if (c === oldControl) {
            return;
        }
        this.$set(this.ctrl, "items", "");
        if (this.setControl) {
            this.setControl();
        }
        if (this.style) {
            this.style
                .trim()
                .split(";")
                .forEach((s) => {
                let [key, value] = s.trim().split(":");
                this.styleObj[key] = value;
            });
        }
        else {
            this.styleObj = {};
        }
        this.subscribeValueChange();
        this.unRefSubscription(oldControl);
        this.unRefSubscriptionTimer(oldControl);
        // const opts = this.controlOpts as any;
        // if (opts.onChange) {
        //     const _ctrl = this.ctrl as FormControl<any>;
        //     if (!this.onChangeSubscription) {
        //         const onChange = new Function('value', 'oldValue', 'form', opts.onChange);
        //         // const _this = this;
        //         const func = (change: ControlValueChange) => {
        //             const proxy = this.getThisProxy()
        //             onChange.call(proxy, change.value, change.oldValue, proxy);
        //         };
        //         this.onChangeSubscription = _ctrl.valueChange.subscribe(func);
        //     }
        // }
    }
    subscribeValueChange() {
        const ctrl = this.ctrl;
        if (!ctrl || !ctrl.valueChange) {
            return;
        }
        if (ctrl && ctrl.options && ctrl.options.hasOwnProperty("dataLinkage")) {
            //@ts-ignore
            const dataLinkageOption = JSON.parse(ctrl.options.dataLinkage);
            // 解析dataLinkage, 获取condition、fillProperty、targetModel
            const { condition, fillProperty, targetModel } = dataLinkageOption;
            console.log("------------------dataLinkage-------------", ctrl.id);
            let fillPropertyArr = fillProperty ? fillProperty.split('=') : [];
            if (fillPropertyArr.length !== 2)
                return;
            let fillSrc = fillPropertyArr[0].substring(1, fillPropertyArr[0].length - 2);
            let fillTar = fillPropertyArr[1].substring(2, fillPropertyArr[1].length - 1);
            const condArr = condition ? condition.split('&&') : [];
            let isOnlyMainCondition = condition.indexOf('.') === -1;
            condArr.forEach(x => {
                let arr = x.split('=');
                let currentKey = arr[0].substring(1, arr[0].length - 2);
                let targetKey = arr[1].substring(2, arr[1].length - 1);
                let { key: currentKeyCode } = this.formatKey(currentKey);
                let controller = null;
                const idx = currentKeyCode.indexOf('.');
                if (idx > -1) {
                    // 子表条件
                    let rowIndex = ctrl.options.rowIndex || 0;
                    const sheetKey = currentKeyCode.substring(0, idx);
                    const controlKey = currentKeyCode.substr(idx + 1);
                    const sheetCtrl = this.findController(sheetKey);
                    if (sheetCtrl) {
                        const row = sheetCtrl.rows[rowIndex];
                        controller = row.findChild(controlKey);
                    }
                }
                else {
                    controller = this.findController(currentKeyCode);
                }
                if (controller && controller.valueChange) {
                    const optimizationValChange = controller.valueChange.pipe(debounceTime(500));
                    optimizationValChange.subscribe(() => {
                        setTimeout(() => {
                            let filterArr = [];
                            let extraArr = [];
                            condArr.forEach(item => {
                                let innerArr = item.split('=');
                                let innerCurrentKey = innerArr[0].substring(1, innerArr[0].length - 2);
                                let innerTargetKey = innerArr[1].substring(2, innerArr[1].length - 1);
                                let { key: innerCode } = this.formatKey(innerCurrentKey);
                                let ctrl = null;
                                const idx = innerCode.indexOf('.');
                                if (idx > -1) {
                                    // 子表条件
                                    let rowIndex = controller.options.rowIndex || 0;
                                    const sheetKey = innerCode.substring(0, idx);
                                    const controlKey = innerCode.substr(idx + 1);
                                    const sheetCtrl = this.findController(sheetKey);
                                    if (sheetCtrl) {
                                        const row = sheetCtrl.rows[rowIndex];
                                        ctrl = row.findChild(controlKey);
                                    }
                                }
                                else {
                                    ctrl = this.findController(innerCode);
                                }
                                if (ctrl) {
                                    filterArr.push({
                                        key: innerTargetKey,
                                        val: ctrl.value
                                    });
                                    extraArr.push(innerCurrentKey);
                                }
                            });
                            this.emitOnDataLinkage({
                                filter: filterArr,
                                fillProperty: {
                                    src: fillSrc,
                                    target: fillTar
                                },
                                extraCond: extraArr,
                                targetModel
                            });
                        }, 500);
                    });
                }
            });
        }
        this.unsubscribeValueChange();
        this.valueChangeSubscription = ctrl.propertyChange.subscribe((change) => {
            switch (change.name) {
                case PropertyNames.Value:
                    this.emitControlOnChange(change);
                    if (this.handleValueChange) {
                        if (!isEqual(change.value, change.oldValue)) {
                            this.handleValueChange(change.value, change);
                        }
                    }
                    break;
                // case PropertyNames.Readonly:
                //   this.control.edit = change.value === false;
                //   break;
            }
        });
    }
    emitControlOnChange(change) {
        const opts = this.controlOpts;
        if (this.ctrl.inSheet) { // 如果在子表内触发了事件 则要标记当前行状态
            const parentKey = this.control.parentKey;
            const key = this.control.key;
            const options = this.ctrl.options;
            this.changeFormSheetRowStatus(parentKey, key, options);
        }
        if (!opts.onChange) {
            return;
        }
        if (!this.onChangeFn) {
            this.onChangeFn = new Function("value", "oldValue", "form", opts.onChange);
        }
        const proxy = this.getThisProxy();
        this.onChangeFn.call(proxy, change.value, change.oldValue, proxy);
    }
    emitOnDataLinkage(params) {
        // 传入的参数格式key_dataItemType_fromControlType
        let isOnlyMainCondition = params.extraCond.join('&&').indexOf('.') === -1;
        let isSheetItem = params.fillProperty.src.indexOf('.') > -1;
        let { key: srcKey } = this.formatKey(params.fillProperty.src);
        const ctrl = this.ctrl;
        let controller = null;
        let rowIndex = 0;
        let filterArr = [];
        let mulRelevantKeyArr = [];
        params.filter.forEach((x) => {
            let { key: xKey, dataItemType: xDataItemType, formControlType: xFormControlType } = this.formatKey(x.key);
            if (Number(xFormControlType) === 81) {
                mulRelevantKeyArr.push(xKey);
            }
            let filterVal = this.formatVal(x.val, Number(xFormControlType));
            filterArr.push({
                propertyCode: xKey,
                propertyType: Number(xDataItemType),
                propertyValue: filterVal,
                //@ts-ignore
                op: this.formatOp(Number(xFormControlType), filterVal)
            });
        });
        let { key: xKey, dataItemType: xDataItemType, formControlType: targetType } = this.formatKey(params.fillProperty["target"]);
        let mixParams = {
            filters: filterArr,
            mobile: false,
            page: 0,
            size: 20,
            queryCode: params.targetModel,
            schemaCode: params.targetModel,
            // @ts-ignore
            options: {
                // @ts-ignore
                customDisplayColumns: [xKey].concat(mulRelevantKeyArr),
                // @ts-ignore
                queryDisplayType: 1
            },
            // @ts-ignore
            customizedQuery: true
        };
        if (ctrl.options.inSheet) {
            if (isOnlyMainCondition && isSheetItem) {
                // 只有主表条件并且联动项是子表项, 需求要求将满足条件的数据项加到子表中
                if (rowIndex === 0) {
                    listApi.getQueryList(mixParams).then(res => {
                        let sheetKey = srcKey.substring(0, srcKey.indexOf('.'));
                        let itemKey = srcKey.substring(srcKey.indexOf('.') + 1);
                        let sheet = this.findController(sheetKey);
                        let sheetControl = this.getFormControls([sheetKey])[0];
                        if (res.errcode === 0 && res.data && Array.isArray(res.data.content) && res.data.content.length > 0) {
                            let rows = [];
                            res.data.content.forEach((item) => {
                                let vals = Object.create(null);
                                vals[itemKey] = '';
                                rows.push(vals);
                            });
                            sheet.value = rows;
                            setTimeout(() => {
                                let rows = [];
                                res.data.content.forEach((item, index) => {
                                    let rowData = Object.create(null);
                                    let val = item.data[xKey];
                                    switch (Number(targetType)) {
                                        case FormControlType.Text:
                                        case FormControlType.Radio:
                                        case FormControlType.Dropdown:
                                            if (typeof val === "string" && val.length <= 200) {
                                                rowData[itemKey] = val;
                                            }
                                            else if (typeof val !== "object") {
                                                rowData[itemKey] = val.toString();
                                            }
                                            else if (typeof val === "object") {
                                                rowData[itemKey] = JSON.stringify(val);
                                            }
                                            break;
                                        case FormControlType.SequenceNo:
                                        case FormControlType.Textarea:
                                        case FormControlType.Description:
                                        case FormControlType.Title:
                                            if (typeof val === "string") {
                                                rowData[itemKey] = val;
                                            }
                                            break;
                                        case FormControlType.Number:
                                            if (val === "") {
                                                rowData[itemKey] = null;
                                            }
                                            rowData[itemKey] = Number(val);
                                            break;
                                        case FormControlType.Logic:
                                            rowData[itemKey] = Boolean(val);
                                            break;
                                        case FormControlType.Date:
                                        case FormControlType.CreatedTime:
                                        case FormControlType.ModifiedTime:
                                            if (val instanceof Date) {
                                                rowData[itemKey] = val;
                                            }
                                            else if (typeof val === "string" && val) {
                                                try {
                                                    let str = val
                                                        .replace(/-/g, "/") // iOS兼容
                                                        .replace(/T/g, " "); //修复2019-09-17T06:21:07.000字符不能new Date的问题
                                                    let date = new Date(str);
                                                    if (date.getFullYear() > 0) {
                                                        rowData[itemKey] = date;
                                                    }
                                                }
                                                catch (_a) { }
                                            }
                                            break;
                                        case FormControlType.Time:
                                            if (typeof val === "string" && val) {
                                                rowData[itemKey] = moment(val, "HH:mm:ss");
                                            }
                                            break;
                                        case FormControlType.Checkbox:
                                            if (typeof val === "string") {
                                                rowData[itemKey] = val.split(";").filter((x) => !!x);
                                            }
                                            else if (typeof val === "object") {
                                                rowData[itemKey] = [val];
                                            }
                                            else if (Array.isArray(val) &&
                                                val.some((x) => typeof x === "string")) {
                                                rowData[itemKey] = val;
                                            }
                                            break;
                                        case FormControlType.Location:
                                            if (typeof val === "string") {
                                                try {
                                                    val = JSON.parse(val);
                                                }
                                                catch (_b) { }
                                            }
                                            if (typeof val === "object") {
                                                rowData[itemKey] = val;
                                            }
                                            break;
                                        case FormControlType.Image:
                                        case FormControlType.Attachment:
                                        case FormControlType.Signature:
                                        case FormControlType.StaffSelector:
                                        case FormControlType.StaffMultiSelector:
                                        case FormControlType.DepartmentSelector:
                                        case FormControlType.DepartmentMultiSelector:
                                        case FormControlType.CreateBy:
                                        case FormControlType.ModifyBy:
                                        case FormControlType.OwnerId:
                                        case FormControlType.CreateByParentId:
                                        case FormControlType.Sheet:
                                            if (typeof val === "string") {
                                                try {
                                                    val = JSON.parse(val);
                                                }
                                                catch (_c) { }
                                            }
                                            if (Array.isArray(val) && val.some((x) => typeof x === "object")) {
                                                rowData[itemKey] = val;
                                            }
                                            break;
                                        case FormControlType.ApprovalOpinion:
                                            if (typeof val === "string") {
                                                rowData[itemKey] = {
                                                    content: val,
                                                };
                                            }
                                            else if (typeof val === "object" &&
                                                typeof val.content === "string") {
                                                rowData[itemKey] = val;
                                            }
                                            break;
                                        case FormControlType.DateRange:
                                        case FormControlType.NumberRange:
                                        case FormControlType.TimeRange:
                                            if (Array.isArray(val)) {
                                                rowData[itemKey] = val;
                                            }
                                            break;
                                        case FormControlType.ReverseRelevance:
                                        case FormControlType.RelevanceForm:
                                        case FormControlType.RelevanceFormEx:
                                        case FormControlType.Address:
                                            if (typeof val === "string") {
                                                try {
                                                    val = JSON.parse(val);
                                                }
                                                catch (_d) { }
                                            }
                                            if (typeof val === "object") {
                                                rowData[itemKey] = val;
                                            }
                                            break;
                                    }
                                    rows.push(rowData);
                                });
                                sheet.value = rows;
                            }, 10);
                        }
                        else {
                            sheet.value = [];
                        }
                    });
                }
            }
            else {
                const idx = srcKey.indexOf('.');
                rowIndex = ctrl.options.rowIndex || 0;
                const sheetKey = srcKey.substring(0, idx);
                const controlKey = srcKey.substr(idx + 1);
                const sheetCtrl = this.findController(sheetKey);
                if (sheetCtrl) {
                    const row = sheetCtrl.rows[rowIndex];
                    controller = row.findChild(controlKey);
                }
                listApi.getQueryList(mixParams).then(res => {
                    if (res.errcode === 0 && res.data && Array.isArray(res.data.content) && res.data.content.length > 0) {
                        let val = res.data.content[0]["data"][xKey];
                        //根据目标控件类型格式化值
                        switch (Number(targetType)) {
                            case FormControlType.Text:
                            case FormControlType.Radio:
                            case FormControlType.Dropdown:
                                if (typeof val === "string" && val.length <= 200) {
                                    controller.value = val;
                                }
                                else if (typeof val !== "object") {
                                    controller.value = val.toString();
                                }
                                else if (typeof val === "object") {
                                    controller.value = JSON.stringify(val);
                                }
                                break;
                            case FormControlType.SequenceNo:
                            case FormControlType.Textarea:
                            case FormControlType.Description:
                            case FormControlType.Title:
                                if (typeof val === "string") {
                                    controller.value = val;
                                }
                                break;
                            case FormControlType.Number:
                                if (val === "") {
                                    controller.value = null;
                                }
                                controller.value = Number(val);
                                break;
                            case FormControlType.Logic:
                                controller.value = Boolean(val);
                                break;
                            case FormControlType.Date:
                            case FormControlType.CreatedTime:
                            case FormControlType.ModifiedTime:
                                if (val instanceof Date) {
                                    controller.value = val;
                                }
                                else if (typeof val === "string" && val) {
                                    try {
                                        let str = val
                                            .replace(/-/g, "/") // iOS兼容
                                            .replace(/T/g, " "); //修复2019-09-17T06:21:07.000字符不能new Date的问题
                                        let date = new Date(str);
                                        if (date.getFullYear() > 0) {
                                            controller.value = date;
                                        }
                                    }
                                    catch (_a) { }
                                }
                                break;
                            case FormControlType.Time:
                                if (typeof val === "string" && val) {
                                    controller.value = moment(val, "HH:mm:ss");
                                }
                                break;
                            case FormControlType.Checkbox:
                                if (typeof val === "string") {
                                    controller.value = val.split(";").filter((x) => !!x);
                                }
                                else if (typeof val === "object") {
                                    controller.value = [val];
                                }
                                else if (Array.isArray(val) &&
                                    val.some((x) => typeof x === "string")) {
                                    controller.value = val;
                                }
                                break;
                            case FormControlType.Location:
                                if (typeof val === "string") {
                                    try {
                                        val = JSON.parse(val);
                                    }
                                    catch (_b) { }
                                }
                                if (typeof val === "object") {
                                    controller.value = val;
                                }
                                break;
                            case FormControlType.Image:
                            case FormControlType.Attachment:
                            case FormControlType.Signature:
                            case FormControlType.StaffSelector:
                            case FormControlType.StaffMultiSelector:
                            case FormControlType.DepartmentSelector:
                            case FormControlType.DepartmentMultiSelector:
                            case FormControlType.CreateBy:
                            case FormControlType.ModifyBy:
                            case FormControlType.OwnerId:
                            case FormControlType.CreateByParentId:
                            case FormControlType.Sheet:
                                if (typeof val === "string") {
                                    try {
                                        val = JSON.parse(val);
                                    }
                                    catch (_c) { }
                                }
                                if (Array.isArray(val) && val.some((x) => typeof x === "object")) {
                                    controller.value = val;
                                }
                                break;
                            case FormControlType.ApprovalOpinion:
                                if (typeof val === "string") {
                                    controller.value = {
                                        content: val,
                                    };
                                }
                                else if (typeof val === "object" &&
                                    typeof val.content === "string") {
                                    controller.value = val;
                                }
                                break;
                            case FormControlType.DateRange:
                            case FormControlType.NumberRange:
                            case FormControlType.TimeRange:
                                if (Array.isArray(val)) {
                                    controller.value = val;
                                }
                                break;
                            case FormControlType.ReverseRelevance:
                            case FormControlType.RelevanceForm:
                            case FormControlType.RelevanceFormEx:
                            case FormControlType.Address:
                                if (typeof val === "string") {
                                    try {
                                        val = JSON.parse(val);
                                    }
                                    catch (_d) { }
                                }
                                if (typeof val === "object") {
                                    controller.value = val;
                                }
                                break;
                        }
                    }
                    else {
                        switch (Number(targetType)) {
                            case FormControlType.Date:
                            case FormControlType.CreatedTime:
                            case FormControlType.ModifiedTime:
                            case FormControlType.Image:
                            case FormControlType.Attachment:
                            case FormControlType.Signature:
                            case FormControlType.StaffSelector:
                            case FormControlType.StaffMultiSelector:
                            case FormControlType.DepartmentSelector:
                            case FormControlType.DepartmentMultiSelector:
                            case FormControlType.CreateBy:
                            case FormControlType.ModifyBy:
                            case FormControlType.OwnerId:
                            case FormControlType.CreateByParentId:
                            case FormControlType.Sheet:
                            case FormControlType.ReverseRelevance:
                            case FormControlType.RelevanceForm:
                            case FormControlType.RelevanceFormEx:
                            case FormControlType.Address:
                            case FormControlType.Number:
                            case FormControlType.Checkbox:
                            case FormControlType.Logic:
                            case FormControlType.Time:
                                controller.value = null;
                                break;
                            default:
                                controller.value = "";
                                break;
                        }
                    }
                });
            }
        }
        else {
            controller = this.findController(srcKey);
            listApi.getQueryList(mixParams).then(res => {
                if (res.errcode === 0 && res.data && Array.isArray(res.data.content) && res.data.content.length > 0) {
                    let val = res.data.content[0]["data"][xKey];
                    //根据目标控件类型格式化值
                    switch (Number(targetType)) {
                        case FormControlType.Text:
                        case FormControlType.Radio:
                        case FormControlType.Dropdown:
                            if (typeof val === "string" && val.length <= 200) {
                                controller.value = val;
                            }
                            else if (typeof val !== "object") {
                                controller.value = val.toString();
                            }
                            else if (typeof val === "object") {
                                controller.value = JSON.stringify(val);
                            }
                            break;
                        case FormControlType.SequenceNo:
                        case FormControlType.Textarea:
                        case FormControlType.Description:
                        case FormControlType.Title:
                            if (typeof val === "string") {
                                controller.value = val;
                            }
                            break;
                        case FormControlType.Number:
                            if (val === "") {
                                controller.value = null;
                            }
                            controller.value = Number(val);
                        case FormControlType.Logic:
                            controller.value = Boolean(val);
                        case FormControlType.Date:
                        case FormControlType.CreatedTime:
                        case FormControlType.ModifiedTime:
                            if (val instanceof Date) {
                                controller.value = val;
                            }
                            else if (typeof val === "string" && val) {
                                try {
                                    let str = val
                                        .replace(/-/g, "/") // iOS兼容
                                        .replace(/T/g, " "); //修复2019-09-17T06:21:07.000字符不能new Date的问题
                                    let date = new Date(str);
                                    if (date.getFullYear() > 0) {
                                        controller.value = date;
                                    }
                                }
                                catch (_a) { }
                            }
                            break;
                        case FormControlType.Time:
                            if (typeof val === "string" && val) {
                                controller.value = moment(val, "HH:mm:ss");
                            }
                            break;
                        case FormControlType.Checkbox:
                            if (typeof val === "string") {
                                controller.value = val.split(";").filter((x) => !!x);
                            }
                            else if (typeof val === "object") {
                                controller.value = [val];
                            }
                            else if (Array.isArray(val) &&
                                val.some((x) => typeof x === "string")) {
                                controller.value = val;
                            }
                            break;
                        case FormControlType.Location:
                            if (typeof val === "string") {
                                try {
                                    val = JSON.parse(val);
                                }
                                catch (_b) { }
                            }
                            if (typeof val === "object") {
                                controller.value = val;
                            }
                            break;
                        case FormControlType.Image:
                        case FormControlType.Attachment:
                        case FormControlType.Signature:
                        case FormControlType.StaffSelector:
                        case FormControlType.StaffMultiSelector:
                        case FormControlType.DepartmentSelector:
                        case FormControlType.DepartmentMultiSelector:
                        case FormControlType.CreateBy:
                        case FormControlType.ModifyBy:
                        case FormControlType.OwnerId:
                        case FormControlType.CreateByParentId:
                        case FormControlType.Sheet:
                            if (typeof val === "string") {
                                try {
                                    val = JSON.parse(val);
                                }
                                catch (_c) { }
                            }
                            if (Array.isArray(val) && val.some((x) => typeof x === "object")) {
                                controller.value = val;
                            }
                            break;
                        case FormControlType.ApprovalOpinion:
                            if (typeof val === "string") {
                                controller.value = {
                                    content: val,
                                };
                            }
                            else if (typeof val === "object" &&
                                typeof val.content === "string") {
                                controller.value = val;
                            }
                            break;
                        case FormControlType.DateRange:
                        case FormControlType.NumberRange:
                        case FormControlType.TimeRange:
                            if (Array.isArray(val)) {
                                controller.value = val;
                            }
                            break;
                        case FormControlType.ReverseRelevance:
                        case FormControlType.RelevanceForm:
                        case FormControlType.RelevanceFormEx:
                        case FormControlType.Address:
                            if (typeof val === "string") {
                                try {
                                    val = JSON.parse(val);
                                }
                                catch (_d) { }
                            }
                            if (typeof val === "object") {
                                controller.value = val;
                            }
                            break;
                    }
                }
                else {
                    switch (Number(targetType)) {
                        case FormControlType.Date:
                        case FormControlType.CreatedTime:
                        case FormControlType.ModifiedTime:
                        case FormControlType.Image:
                        case FormControlType.Attachment:
                        case FormControlType.Signature:
                        case FormControlType.StaffSelector:
                        case FormControlType.StaffMultiSelector:
                        case FormControlType.DepartmentSelector:
                        case FormControlType.DepartmentMultiSelector:
                        case FormControlType.CreateBy:
                        case FormControlType.ModifyBy:
                        case FormControlType.OwnerId:
                        case FormControlType.CreateByParentId:
                        case FormControlType.Sheet:
                        case FormControlType.ReverseRelevance:
                        case FormControlType.RelevanceForm:
                        case FormControlType.RelevanceFormEx:
                        case FormControlType.Address:
                        case FormControlType.Number:
                        case FormControlType.Checkbox:
                        case FormControlType.Logic:
                        case FormControlType.Time:
                            controller.value = null;
                            break;
                        default:
                            controller.value = "";
                            break;
                    }
                }
            });
        }
    }
    // 更新子表某一行的状态
    /**
     * 初始状态，未做任何改变
     * Unchanged
     */
    /**
     * 已新增，保存所有离线的新增
     * Added
     */
    /**
     * 已删除，对应数据库中的需要删除的记录
     * Deleted
     */
    /**
     * 已修改，对应数据库中需要修改的记录
     * Modified
     */
    changeFormSheetRowStatus(parentKey, key, options) {
        // 通过当前控件「parentKey」找到子表
        const sheetCtrl = this.findController(parentKey);
        const value = sheetCtrl.value;
        value.forEach((item, index) => {
            if (index === options.rowIndex) {
                if (!item.id) {
                    item.rowStatus = 'Added';
                }
                else {
                    item.rowStatus = 'Modified';
                }
            }
        });
        sheetCtrl.value = value;
    }
    // 传入的参数格式key_dataItemType_fromControlType
    formatKey(keyStr) {
        let _lastIndex = keyStr.lastIndexOf('_');
        let _last2rdIndex = keyStr.lastIndexOf('_', _lastIndex - 1);
        let key = keyStr.substring(0, _last2rdIndex);
        let dataItemType = keyStr.substring(_last2rdIndex + 1, _lastIndex);
        let formControlType = keyStr.substr(_lastIndex + 1);
        return {
            key,
            dataItemType,
            formControlType
        };
    }
    // 根据表单控件类型去格式化值
    formatVal(val, type) {
        let propertyValue = null;
        if (val) {
            switch (type) {
                case 1:
                case 2:
                case 4:
                case 5:
                case 7:
                case 8:
                    propertyValue = String(val);
                    break;
                case 3: // 日期
                    propertyValue = val instanceof Date ? dateFormat.formatter(val, "YYYY-MM-DD HH:mm:ss") : val;
                    break;
                case 6: // 复选框
                    propertyValue = val.join(';');
                    break;
                case 14: // 地址
                    if (val && Object.keys(val).length > 0) {
                        propertyValue = JSON.stringify(val);
                    }
                    else {
                        propertyValue = null;
                    }
                    break;
                case 50: // 人员单复选
                case 51:
                case 60:
                case 61:
                    let tmpVal = val.map((m) => {
                        return {
                            id: m.id,
                            unitType: m.unitType,
                            name: m.name
                        };
                    });
                    propertyValue = JSON.stringify(tmpVal);
                    break;
                case 80:
                    propertyValue = val.id;
                    break;
                case 81:
                    propertyValue = val.map((x) => x.id).join(';');
                    break;
                default:
                    propertyValue = String(val);
                    break;
            }
        }
        else {
            return "";
        }
        return propertyValue;
    }
    formatOp(type, val) {
        switch (type) {
            case 6:
            case 14:
            case 80:
            case 81:
                return "Like";
            case 50:
            case 51:
            case 60:
            case 61:
                // 选人选组织控件 当没有值时 需要传Eq,有值需要传Like
                if (!val) {
                    return "Eq";
                }
                else {
                    return "Like";
                }
            default:
                return "Eq";
        }
    }
    validate() {
        this.ctrl.validate(false);
    }
    // countLengthOf(s: string) {
    //     if (!s) {
    //         return 0;
    //     }
    //     const reg = /[\u4e00-\u9fa5]+/;
    //     let result: RegExpExecArray | null;
    //     let len = 0;
    //     while (result = reg.exec(s), result !== null) {
    //         len += result[0].length * 2;
    //         s = s.replace(reg, '');
    //     }
    //     len += s.length;
    //     return len;
    // }
    /**
     *
     * @param formControls 所有的control
     * @param exp
     */
    parseConditions(formControls, exp) {
        console.log(formControls, 'formControls');
        let segs = [];
        const results = [];
        if (exp.indexOf("||") > -1) {
            segs = exp.split(" || ");
        }
        else {
            if (exp.indexOf("&&") > -1) {
                segs = exp.split(" && ");
            }
            else {
                segs = [exp];
            }
        }
        for (const seg of segs) {
            const fields = seg.split(" ");
            const code = fields[2].substring(1, fields[2].length - 1);
            let ctrl;
            let control;
            const idx = code.indexOf(".");
            if (idx > -1) {
                const parentCode = code.substring(0, idx);
                const childCode = code.substring(idx + 1);
                const sheet = formControls.find((c) => c.key === parentCode);
                if (sheet) {
                    control = sheet.columns.find((c) => c.key === childCode);
                }
                const sheetCtrl = this.findController(parentCode);
                if (sheetCtrl &&
                    this.ctrl.options &&
                    typeof this.ctrl.options.rowIndex === "number") {
                    const row = sheetCtrl.rows[this.ctrl.options.rowIndex];
                    ctrl = row.findChild(childCode);
                }
            }
            else {
                ctrl = this.findController(code);
                control = formControls.find((c) => c.key === code);
            }
            if (!ctrl || !control) {
                continue;
            }
            const type = ControlHelper.mapToDataItemType(control.type);
            let operator = OperatorService.findByLabel(type, fields[1]);
            if (!operator) {
                continue;
            }
            // let val: any;
            // if (
            //   !(
            //     operator.value === DateItemOperatorType.IsNull ||
            //     operator.value === DateItemOperatorType.IsNotNull
            //   )
            // ) {
            //   val = fields[2];
            //   switch (type) {
            //     case DataItemType.Number:
            //       val = Number(val);
            //       break;
            //     case DataItemType.Logic:
            //       val = val === "true" ? 1 : 0;
            //       break;
            //     case DataItemType.Date:
            //     case DataItemType.ShortText:
            //     case DataItemType.LongText:
            //       val = val.substring(1, val.length - 1);
            //       break;
            //     case DataItemType.StaffSelector:
            //       if (val) {
            //         try {
            //           val = JSON.parse(val);
            //         } catch (e) {
            //           console.log("initModel", e);
            //         }
            //       }
            //       break;
            //   }
            // }
            results.push({
                code: fields[0],
                control,
                controller: ctrl,
                propertyType: type,
                operatorType: operator.value,
            });
        }
        return results;
    }
    countLengthOf(s) {
        if (!s) {
            return 0;
        }
        return s.length;
    }
    subscribePropertyChange(fn) {
        const ctrl = this.findController(this.id);
        if (!ctrl) {
            return;
        }
        if (this.propChangeSubscription) {
            this.propChangeSubscription.add(ctrl.propertyChange.subscribe(fn));
        }
        else {
            this.propChangeSubscription = ctrl.propertyChange.subscribe(fn);
        }
    }
    unsubscribeValueChange() {
        if (this.valueChangeSubscription) {
            this.valueChangeSubscription.unsubscribe();
        }
    }
    unsubscribe() {
        if (this.onChangeSubscription) {
            this.onChangeSubscription.unsubscribe();
        }
        if (this.propChangeSubscription) {
            this.propChangeSubscription.unsubscribe();
        }
    }
    /**
     * 取消control中注册的订阅事件
     * @param control
     */
    unRefSubscription(control) {
        if (control && control.refSubscription && control.refSubscription.length) {
            control.refSubscription.forEach((subscription) => {
                subscription.unsubscribe();
            });
        }
        ;
    }
    /**
     * 清理control中订阅事件延时器
     * @param control
     */
    unRefSubscriptionTimer(control) {
        if (control && control.refSubscriptionTimer && control.refSubscriptionTimer.length) {
            control.refSubscriptionTimer.forEach((timer) => {
                clearTimeout(timer);
            });
        }
        ;
    }
    destroyed() {
        this.unsubscribe();
        this.unsubscribeValueChange();
        this.unRefSubscription(this.control);
        this.unRefSubscriptionTimer(this.control);
    }
}
tslib_1.__decorate([
    Prop()
], BaseControl.prototype, "control", void 0);
tslib_1.__decorate([
    Watch("ctrl.items")
], BaseControl.prototype, "onCtrlItemsChange", null);
tslib_1.__decorate([
    Inject()
], BaseControl.prototype, "findController", void 0);
tslib_1.__decorate([
    Inject()
], BaseControl.prototype, "getController", void 0);
tslib_1.__decorate([
    Inject()
], BaseControl.prototype, "getFormControls", void 0);
tslib_1.__decorate([
    Inject()
], BaseControl.prototype, "getScrollEl", void 0);
tslib_1.__decorate([
    Inject()
], BaseControl.prototype, "valChange", void 0);
tslib_1.__decorate([
    Inject()
], BaseControl.prototype, "getDataItem", void 0);
tslib_1.__decorate([
    Inject()
], BaseControl.prototype, "getRelativeDataList", void 0);
tslib_1.__decorate([
    Inject()
], BaseControl.prototype, "getSourceType", void 0);
tslib_1.__decorate([
    Watch("control", {
        immediate: true,
    })
], BaseControl.prototype, "onControlChange", null);
